<template>
  <span
    class="brand-logo"
    :class="[`brand-logo--${variant}`, { 'brand-logo--reversed': reversed }]"
    role="img"
    :aria-label="ariaLabel"
  >
    <svg class="brand-logo__mark" viewBox="0 0 96 96" fill="none" aria-hidden="true">
      <rect class="brand-logo__rect brand-logo__rect--back" x="14" y="30" width="44" height="36" rx="13" stroke-width="7" />
      <rect class="brand-logo__rect brand-logo__rect--front" x="38" y="30" width="44" height="36" rx="13" stroke-width="7" />
    </svg>
    <span v-if="variant === 'lockup'" class="brand-logo__text">
      <span class="brand-logo__name">
        <span class="brand-logo__name-mute">miri</span><span class="brand-logo__name-accent">dar</span>
      </span>
      <span class="brand-logo__sub">Solutions</span>
    </span>
  </span>
</template>

<script>
// Marca de brand MiriDar — simbolul "linked records" (duoton navy + teal) plus
// wordmark-ul opțional. Sursa de design: docs/design/logo.md.
// SVG inline pentru a moșteni fontul aplicației (Avenir) și tokenii de temă;
// nu se introduc hex-uri în template (vezi docs/design.md).
export default {
  name: "BrandLogo",
  props: {
    // "symbol" = doar marca (navbar, cadre pătrate mici); "lockup" = marca + wordmark.
    variant: {
      type: String,
      default: "symbol",
      validator: (value) => ["symbol", "lockup"].includes(value),
    },
    // Pe fundaluri închise (navy) marca se inversează: ramă albă + teal.
    reversed: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: "MiriDar",
    },
  },
};
</script>

<style scoped>
.brand-logo {
  display: inline-flex;
  align-items: center;
  gap: 0.22em;
  line-height: 1;
}

.brand-logo__mark {
  display: block;
  width: 100%;
  height: 100%;
}

.brand-logo--lockup .brand-logo__mark {
  flex: 0 0 auto;
  width: 1em;
  height: 1em;
}

.brand-logo__rect--back {
  stroke: rgb(var(--v-theme-primary));
}

.brand-logo__rect--front {
  stroke: rgb(var(--v-theme-tertiary));
}

.brand-logo--reversed .brand-logo__rect--back {
  stroke: #ffffff;
}

/* Wordmark — folosește fontul global al aplicației (Avenir). */
.brand-logo__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.brand-logo__name {
  font-weight: 700;
  font-size: 0.46em;
  line-height: 0.9;
  letter-spacing: -0.025em;
}

.brand-logo__name-mute {
  color: rgb(var(--v-theme-primary));
}

.brand-logo__name-accent {
  color: rgb(var(--v-theme-tertiary));
}

.brand-logo--reversed .brand-logo__name-mute {
  color: #ffffff;
}

.brand-logo__sub {
  font-size: 0.12em;
  font-weight: 600;
  letter-spacing: 0.34em;
  text-transform: uppercase;
  color: rgb(var(--v-theme-quaternary));
  padding-left: 0.34em;
}

.brand-logo--reversed .brand-logo__sub {
  color: rgba(255, 255, 255, 0.7);
}
</style>
